import React from 'react'
import { StepperContainer } from './StepperContainer'

interface ASNReceptionPageProps {}

export const ASNReceptionPage: React.FC<ASNReceptionPageProps> = () => {
  return <StepperContainer></StepperContainer>
}
